import React from 'react';

// Components
import { LoginForm } from './LoginForm'

// Styles
import { SmartContainer, Stack, Surface } from '../../styles/Containers'
import { StyledAuthSurface } from './RecoverPage';

import logoLeft from '../../assets/logo-left-black-green.png';


export const LoginPage = ({ redirect }) => {
    let path = '/'
    if (redirect) path = redirect

    return (
        <Stack flex align="center" justify="center" padding={10} direction="column">
            <SmartContainer flex align="center" justify="center">
                <img src={logoLeft} alt="Capture Collab Logo" style={{ maxWidth: '200px', width: '76%', height: 'auto', marginBottom: '1em' }} />
            </SmartContainer>
            <StyledAuthSurface maxWidth="400px" textAlign="center">
                <LoginForm redirect={path} />
            </StyledAuthSurface>

        </Stack>
    )
}